import React, { useEffect, useState } from "react";
import { NavLink, Link} from "react-router";
import ThemeSwitcher from './ThemeSwitcher';

function Footer () {
   const [popularactivities, setpopularactivities] = useState([]);
   const [packages, setPackages] = useState([]);
   const [Footerpage, SetFooterpage] = useState([]);
   const [domesticpackages, setDomesticPackages] = useState([]);
   const [domesticcruise, setpopularcruise] = useState([]);
   
  
 useEffect(() => {
    fetch("https://planjourneysglobal.com/admin/api/best_selling_packages")
      .then((res) => res.json())
      .then((data) => {
        setDomesticPackages(data?.data || []); 
      })
      .catch((err) => console.log("API Error:", err));
  }, []);

    useEffect(() => {
      fetch("https://planjourneysglobal.com/admin/api/popular_Packages")
        .then((res) => res.json())
        .then((data) => {
          setPackages(data?.data || []); 
        })
        .catch((err) => console.log("API Error:", err));
    }, []);

    
    useEffect(() => {
      fetch("https://planjourneysglobal.com/admin/api/popular_activities")
        .then(res => res.json())
        .then(res => setpopularactivities(res.data || {}))
        .catch(err => console.log(err));
    }, []);

     useEffect(() => {
      fetch("https://planjourneysglobal.com/admin/api/popular_cruise")
        .then(res => res.json())
        .then(res => setpopularcruise(res.data || {}))
        .catch(err => console.log(err));
    }, []);

 useEffect(() => {
      fetch("https://planjourneysglobal.com/admin/api/footer_page")
        .then(res => res.json())
        .then(res => SetFooterpage(res.data || {}))
        .catch(err => console.log(err));
    }, []);


    
    return(
      <>
  {/* home1 Footer Section Start*/}
      <div className="home7-banner-bottom">
  <div className="container">
    <div className="row gy-md-5 gy-4 align-items-center">
      <div className="col-lg-4 col-md-6  order-lg-1 order-2 d-flex justify-content-md-start justify-content-center">
        <div className="single-contact">
          <div className="icon">
            <svg
              width={16}
              height={16}
              viewBox="0 0 16 16"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g>
                <path d="M15.5645 11.7424L13.3317 9.50954C12.5342 8.7121 11.1786 9.03111 10.8596 10.0678C10.6203 10.7855 9.8229 11.1842 9.1052 11.0247C7.51031 10.626 5.3572 8.55261 4.95848 6.87797C4.71925 6.16024 5.19771 5.36279 5.91542 5.12359C6.9521 4.80461 7.27107 3.44895 6.47363 2.65151L4.24078 0.418659C3.60282 -0.139553 2.64589 -0.139553 2.08768 0.418659L0.57253 1.93381C-0.942617 3.5287 0.732019 7.75516 4.48001 11.5032C8.22801 15.2512 12.4545 17.0056 14.0494 15.4106L15.5645 13.8955C16.1228 13.2575 16.1228 12.3006 15.5645 11.7424Z" />
              </g>
            </svg>
          </div>
          <div className="content">
            <span>Need Help?</span>
            <a href="tel:+971 585437355">+971 585437355</a>
          </div>
        </div>
      </div>
      <div className="col-lg-4  order-lg-2">
        <div className="award-rating-area">
          <img src="/assets/woman-background-free-png.png" alt="award" width={200} height={200} />
         
        </div>
      </div>
      <div className="col-lg-4 col-md-6 d-flex justify-content-lg-end justify-content-center order-lg-3">
        <div className="single-contact">
          <div className="icon">
            <svg
              width={16}
              height={16}
              viewBox="0 0 16 16"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1.96372 3.07415L6.28622 7.39852C7.22897 8.33946 8.77003 8.34027 9.71356 7.39852L14.0361 3.07415C14.0463 3.06399 14.0541 3.0517 14.0591 3.03816C14.064 3.02462 14.0659 3.01016 14.0647 2.99581C14.0634 2.98145 14.059 2.96755 14.0517 2.95509C14.0445 2.94263 14.0346 2.93192 14.0227 2.92371C13.5819 2.61624 13.0455 2.43396 12.4677 2.43396H3.53216C2.95431 2.43396 2.41791 2.61627 1.97703 2.92371C1.96519 2.93192 1.95529 2.94263 1.94805 2.95509C1.9408 2.96755 1.93639 2.98145 1.93512 2.99581C1.93385 3.01016 1.93575 3.02462 1.9407 3.03816C1.94564 3.0517 1.9535 3.06399 1.96372 3.07415ZM0.808595 5.15749C0.808243 4.71811 0.915024 4.28527 1.11969 3.89646C1.12683 3.88275 1.13711 3.87093 1.14969 3.86194C1.16226 3.85295 1.17678 3.84706 1.19207 3.84474C1.20735 3.84242 1.22296 3.84373 1.23764 3.84858C1.25232 3.85343 1.26564 3.86168 1.27653 3.87265L5.54431 8.14043C6.89578 9.49387 9.10322 9.49465 10.4555 8.14043L14.7233 3.87265C14.7342 3.86168 14.7475 3.85343 14.7622 3.84858C14.7769 3.84373 14.7925 3.84242 14.8077 3.84474C14.823 3.84706 14.8376 3.85295 14.8501 3.86194C14.8627 3.87093 14.873 3.88275 14.8801 3.89646C15.0848 4.28527 15.1916 4.71811 15.1912 5.15749V10.843C15.1912 12.3459 13.9687 13.5666 12.4677 13.5666H3.53216C2.03116 13.5666 0.808595 12.3459 0.808595 10.843V5.15749Z"
              />
            </svg>
          </div>
          <div className="content">
            <span>Email Now</span>
            <a href="mailto:at@planjourneys.com">at@planjourneys.com</a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <img
    src="/assets/img/home7/vector/home7-banner-bottom-vector1.svg"
    alt=""
    className="vector1"
  />
  <img
    src="/assets/img/home7/vector/home7-banner-bottom-vector2.svg"
    alt=""
    className="vector2"
  />
</div>
  <footer className="footer-section">


    <div className="container">
       <div className="bottomlist pt-30">
        <h3>Best selling Packages</h3>
        <ul>
      {domesticpackages.map((item, i) => (
              <li key={i}>
                <Link to={`/tour-package/${item.slug}`}>
                 <span> {item.title}</span>
                </Link>
              </li>
            ))}
            </ul>

           
         </div>
      <svg
        className="divider"
        width={1320}
        height={6}
        viewBox="0 0 1320 6"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M5 2.5L0 0.113249V5.88675L5 3.5V2.5ZM1315 3.5L1320 5.88675V0.113249L1315 2.5V3.5ZM4.5 3.5H1315.5V2.5H4.5V3.5Z" />
      </svg>

      <div className="footer-menu-wrap mt-2">
        <div className="row gy-md-4 gy-5">
          <div className="col-lg-3 col-md-4 col-sm-6">
            <div className="footer-logo-and-addition-info">
              <a href="#" className="footer-logo">
                <img src="/assets/img/site-logo.PNG" alt="logo" width={80} />
              </a>
              <div class="address-area">
                                <span>Plan Journeys Global</span>
                               <p> <a className="footerdis" href="/about" > <div dangerouslySetInnerHTML={{ __html: Footerpage.description}}></div></a></p>
                            </div>
              <div className="address-area">
                <span>	Noida office:</span>
                <p><b>403, 4th Floor, Vishal Chambers, Sector-18, Noida - 201301, U.P. India
              </b></p>

                 <span>Dubai Office:</span>
                <p>Plan Journeys Global
                  IFZA Business Park DDP
                  72132-001
                  A1-3641379065
                  Dubai, UAE</p>
              </div>
              <ul className="social-list">
                 <li>
                  <a href="https://whatsapp.com/channel/0029VaANXrkL7UVP6A4fMF3Y" target="_blank">
                    <i className="bx bxl-whatsapp" />
                  </a>
                </li>
                <li>
                  <a href="https://www.facebook.com/planjourneys/" target="_blank">
                    <i className="bx bxl-facebook" />
                  </a>
                </li>
                  <li>
                  <a href=" https://x.com/PlanJourneys" target="_blank">
                    <i className="bx bxl-twitter" />
                  </a>
                </li>
                
                <li>
                  <a href=" https://www.linkedin.com/in/planjourneys/" target="_blank">
                    <i className="bx bxl-linkedin" />
                  </a>
                </li>
                <li>
                  <a href=" https://www.youtube.com/@planjourneysPL" target="_blank">
                    <i className="bx bxl-youtube" />
                  </a>
                </li>
                <li>
                  <a href="https://www.instagram.com/planjourneysglobal" target="_blank">
                    <i className="bx bxl-instagram-alt" />
                  </a>
                </li>
              </ul>
             
            </div>
          </div>
          <div className="col-lg-3 col-md-2 col-sm-6 d-flex justify-content-md-start">
            <div className="footer-widget">
              <div className="widget-title">
                <h5>Popular Packages</h5>
              </div>
              <ul className="widget-list packages">
              {packages.length > 0 ? (
              packages.slice(0, 10).map((item, index) => (
                <li className="swiper-slide" key={index}>
                  <Link to={`/tour-package/${item.slug}`}>
                    {item.title}
                  </Link>
                </li>
              ))
            ) : (
              <p>Loading...</p>
            )}
              </ul>
            </div>
          </div>
          <div className="col-lg-2 col-md-2 col-sm-6 d-flex justify-content-md-end">
            <div className="footer-widget">
              <div className="widget-title">
                <h5>Activities</h5>
              </div>
              <ul className="widget-list activity">
                 {popularactivities.length > 0 ? (
                       popularactivities.slice(0, 10).map((item, index) => (
                         <li className="swiper-slide" key={index}>
                        <Link  to={`/activity/${item.slug}`}>
                                   {item.title}
                                 </Link >
                         </li>
                       ))
                     ) : (
                       <p>Loading...</p>
                     )}
                
              </ul>
            </div>
          </div>
           <div className="col-lg-2 col-md-2 col-sm-6 d-flex justify-content-md-end">
            <div className="footer-widget">
              <div className="widget-title">
                <h5>Cruise</h5>
              </div>
              <ul className="widget-list activity">
                 {domesticcruise.length > 0 ? (
                       domesticcruise.slice(0, 10).map((item, index) => (
                         <li className="swiper-slide" key={index}>
                        <Link  to={`/cruise/${item.slug}`}>
                                   {item.title}
                                 </Link >
                         </li>
                       ))
                     ) : (
                       <p>Loading...</p>
                     )}
                
              </ul>
            </div>
          </div>
          <div className="col-lg-2 col-sm-6 d-flex justify-content-lg-end">
            <div className="footer-widget">
              <div className="widget-title">
                <h5>Resources</h5>
              </div>
                
          <ul className="widget-list">
            <li className=" active">
            <NavLink to="/" end  className="drop-down">
              Home
            </NavLink>
           
          </li>
           <li >
            <NavLink to="/about" end  className="drop-down">
              About
            </NavLink>
           
          </li>
            <li className="menu-item-has-children ">
              <NavLink to="/destination" end className="drop-down">
                Destination
              </NavLink>
              
            </li>
            <li className="menu-item-has-children">
              <NavLink to="/package" className="drop-down">
                Package
              </NavLink>
            </li>
             <li className="menu-item-has-children">
              <NavLink to="/activity" className="drop-down">
                Activity
                
              </NavLink>
             
            </li>
             {/* <li className="menu-item-has-children">
              <NavLink to="/hotel" className="drop-down">
                Hotel
              </NavLink>
              
            
            </li> */}
            <li className="menu-item-has-children">
              <NavLink to="/blog" className="drop-down">
                Blog
              </NavLink>
            
            </li>
            <li className="menu-item-has-children">
              <NavLink to="/visa" className="drop-down">
                Visa
              </NavLink>
             
            </li>
              <li className="menu-item-has-children">
              <NavLink to="/contact" className="drop-down">
                Contact Us
              </NavLink>
             
            </li>
              <li className="menu-item-has-children">
              <NavLink to="/Privecy-Policy" className="drop-down">
               Privecy Policy
              </NavLink>
             
            </li>
            <li className="menu-item-has-children">
              <NavLink to="/term-condition" className="drop-down">
            Term Condition
              </NavLink>
             
            </li>
         
          </ul>
             
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className="footer-bottom">
      <div className="container">
        <div className="copyright-and-payment-method-area">
          <p>
            Copyright 2026 <a href="https://planjourneysglobal.com/">www.planjourneysglobal.com</a> |
            All Right Reserved.
          </p>

        </div>
      </div>
    </div>
  </footer>
<a href="https://api.whatsapp.com/send?phone=971569825050&text=Hi%20Welcome%20to%20Plan%20Journeys%20Global"
   class="whatsapp-icon-floting"
   target="_blank">   
      <svg class="my-float animate__animated animate__pulse animate__infinite" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
    <path d="M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z"/>
</svg>
      
    </a>
    {/* <ThemeSwitcher/> */}

  {/* home1 Footer Section End*/}
</>

    )
}
export default Footer;